import { FeatureFlagFragment } from '../../../graphql/cms-types'
import { TranslateFunc } from '../cms-context'
import { FeatureFlagFunc } from '../types'

type FeatureFlagCurriableFunc = (
  allFeatureFlags: Record<string, FeatureFlagFragment>,
  translate: TranslateFunc,
) => FeatureFlagFunc

export const featureFlagFunc: FeatureFlagCurriableFunc =
  (allFeatureFlags, translate) => flag => {
    if (!allFeatureFlags?.[flag])
      return {
        enabled: false,
      }

    return {
      enabled: allFeatureFlags[flag].enabled,
      heading: allFeatureFlags[flag]?.heading?.reference
        ? translate(allFeatureFlags[flag]?.heading?.reference || '')
        : undefined,
      text: allFeatureFlags[flag]?.text?.reference
        ? translate(allFeatureFlags[flag]?.text?.reference || '')
        : undefined,
      value: allFeatureFlags[flag]?.value || undefined,
      userCreatedAfter:
        (allFeatureFlags[flag]?.userCreatedAfter as string) || undefined,
      userCreatedBefore:
        (allFeatureFlags[flag]?.userCreatedBefore as string) || undefined,
    }
  }
